import { render, staticRenderFns } from "./HochzeitView.vue?vue&type=template&id=34e6854b"
import script from "./HochzeitView.vue?vue&type=script&lang=js"
export * from "./HochzeitView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports